var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LowlyFood from "./LowlyFood";
export default class RecipeCardGenerator {
    static popupateAllRecipeCards(selector = ".recipe-card") {
        const recipeCards = document.querySelectorAll(selector);
        recipeCards.forEach((recipeCard) => __awaiter(this, void 0, void 0, function* () {
            const idString = recipeCard.getAttribute("data-recipe-id");
            if (idString === null) {
                return;
            }
            const id = parseInt(idString);
            const recipe = yield LowlyFood.fetchRecipe(id);
            const element = recipeCard;
            element.style.backgroundImage = `url('${recipe.recipe.image_url}')`;
            const titleElement = document.createElement("div");
            titleElement.classList.add("title");
            const titleText = document.createTextNode(recipe.recipe.name);
            titleElement.appendChild(titleText);
            element.appendChild(titleElement);
            element.setAttribute("href", recipe.link);
            element.setAttribute("target", "_blank");
        }));
    }
}
//# sourceMappingURL=RecipeCardGenerator.js.map